// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_9-1";
export var movingGradient = "_9-4";
export var movingGradientBlock = "_9-2";
export var skeleton = "_9-0";
export var skeletonText = "_9-3";